import { useCourseContext } from '../../../../../../../course/Context';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../../../../i18n';
import { getJoinCourseMessage } from './helpers';

const useFooter = () => {
  const { t } = useTranslation([i18nNS.POLL]);
  const { course } = useCourseContext();

  const joinCourseMessage = getJoinCourseMessage(course);

  return { joinCourseMessage };
};
export default useFooter;
